import { FC } from 'react';

import { MenuButtonTemplate, useDrawerState } from 'components/OnePageTemplates/common';

import styles from './MenuButton.module.scss';

export const MenuButton: FC = () => {
  const { openDrawerHandler } = useDrawerState();

  return <MenuButtonTemplate onClick={openDrawerHandler} variant="hamburger" className={styles.button} />;
};
